import React, { useEffect, useRef } from "react";
import { FiArrowLeft, FiLock } from "react-icons/fi";

export default function DocumentPreview({ lesson, locked, onClose, onUpgrade }) {
  const dialogRef = useRef(null);
  const attachment = lesson.attachments?.[0];
  const name = attachment?.name || lesson.title;
  useEffect(() => {
    const dialog = dialogRef.current, focused = document.activeElement;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    dialog.showModal();
    return () => { dialog.close(); document.body.style.overflow = overflow; focused?.focus(); };
  }, []);
  return <dialog ref={dialogRef} aria-label="Document preview" onCancel={event => { event.preventDefault(); onClose(); }} className="document-full-preview">
    <header className="flex shrink-0 items-center gap-3 border-b border-[var(--app-border)] px-3 py-2 sm:px-5">
      <button autoFocus type="button" aria-label="Back to documents" onClick={onClose} className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg hover:bg-[var(--app-muted)]"><FiArrowLeft className="h-5 w-5" /></button>
      <h1 className="min-w-0 truncate text-base font-semibold" title={name}>{name}</h1>
    </header>
    {locked ? <div className="flex flex-1 flex-col items-center justify-center gap-5"><FiLock className="h-10 w-10" /><button onClick={onUpgrade} className="rounded-md bg-orange-700 px-4 py-3 font-semibold text-white">Upgrade to view</button></div>
      : attachment?.mime === "application/pdf" ? <iframe title={name} src={`${process.env.API_URL}/api/classes/${lesson._id}/documents/${attachment._id}?preview=1#toolbar=0&navpanes=0`} className="min-h-0 w-full flex-1 border-0" />
      : <div className="flex flex-1 items-center justify-center p-6 text-center text-gray-500">Preview unavailable for this format. Ask the owner for a PDF version.</div>}
  </dialog>;
}
